import { render, staticRenderFns } from "./MEM921P01.vue?vue&type=template&id=679b3d16&"
import script from "./MEM921P01.vue?vue&type=script&lang=js&"
export * from "./MEM921P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports